module.exports = __webpack_public_path__ + "img/guessTempo_mode.75615b7b.png";